import React, {Component} from 'react';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import FormValidator from "../FormValidator";
import '../../styles/FormStyle.css';

const initialState = {
  street: '',
  housenumber: '',
  housenumberextension: '',
  postcode: '',
  city: '',
  prefix: '',
  telefon: '',
  email: ''
}

class UserAdress extends Component{
  constructor(props){
    super(props);
    this.validator = new FormValidator([
      {
        field: 'street',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die Adresse an.'
      },
      {
        field: 'housenumber',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Pflichtfeld'
      },
      {
        field: 'housenumber',
        method: 'isInt',
        validWhen: true,
        message: 'Muss eine Nummer sein.'
      },
      {
        field: 'postcode',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die PLZ an.'
      },
      {
        field: 'postcode',
        method: 'isInt',
        validWhen: true,
        message: 'PLZ muss eine Nummer sein.'
      },
      {
        field: 'postcode',
        method: 'isLength',
        args: [{min: 5, max: 5}],
        validWhen: true,
        message: 'PLZ besteht aus 5 Ziffern.'
      },
      {
        field: 'city',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie den Ort an.'
      },   
      {
        field: 'email',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die E-Mail-Adresse an.'
      },
      {
        field: 'email',
        method: 'isEmail',
        args: [{ignore_whitespace:true}],
        validWhen: true,
        message: 'Bitte überprüfen sie ihre Angabe.'
      },
    ]);
    
    this.state = {
      ...initialState,
      ...props.state,
      validation: this.validator.valid()
    }

    const isVal = this.validator.validate(this.state);
    props.isValidForm(isVal.isValid, 'adressValidation');

    this.handleChange = this.handleChange.bind(this);
  }



  componentDidUpdate() {
    // check if the upper instance has resettet its state
    if(this.state.street !== this.props.state.street){
      // reset too
      this.setState({
        ...this.props.state
      });
    }
  }

  handleChange(event) {
    this.props.changeHandler(event);

    this.setState({
      [event.target.name]: event.target.value
    }, () => { // callback to send validation to upper instance after state was updatet
      const isVal = this.validator.validate(this.state);
      this.props.isValidForm(isVal.isValid, 'adressValidation');
    });
  }

  render(){
    // validator will start alerting after first submission
    let validation = this.props.submitted ? this.validator.validate(this.state) : this.state.validation;

    return (
      <div>
      <Row>
        <Col md={4}>
          <FormGroup>
            <div className={validation.street.isInvalid ? 'has-error' : ''}>
              <Label for="street">Straße*</Label>
              <Input type="text" value={this.state.street} name="street" id="street" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.street.message}</span>
            </div>
          </FormGroup>
        </Col>
        <Col md={1}>
          <FormGroup>
            <div className={validation.housenumber.isInvalid ? 'has-error' : ''}>
              <Label for="housenumber">Hausnr.*</Label>
              <Input type="text" value={this.state.housenumber} name="housenumber" id="housenumber" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.housenumber.message}</span>
            </div>
          </FormGroup>
        </Col>
        <Col md={1}>
          <FormGroup>
            <div>
              <Label for="housenumberextension">Erw.</Label>
              <Input type="text" value={this.state.housenumberextension} name="housenumberextension" id="housenumberextension" onChange={this.handleChange.bind(this)}/>
            </div>
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup>
            <div className={validation.postcode.isInvalid ? 'has-error' : ''}>
              <Label for="postcode">Postleitzahl*</Label>
              <Input type="number" value={this.state.postcode} name="postcode" id="postcode" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.postcode.message}</span>
            </div>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <div className={validation.city.isInvalid ? 'has-error' : ''}>
              <Label for="city">Ort*</Label>
              <Input type="text" value={this.state.city} name="city" id="city" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.city.message}</span>
            </div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
      <Col md={2}>
          <FormGroup>
            <div>
              <Label for="prefix">Vorwahl</Label>
              <Input type="number" value={this.state.prefix} name="prefix" id="prefix" onChange={this.handleChange.bind(this)}/>
            </div>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <div>
              <Label for="telefon">Telefon</Label>
              <Input type="number" value={this.state.telefon} name="telefon" id="telefon" onChange={this.handleChange.bind(this)}/>
            </div>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <div className={validation.email.isInvalid ? 'has-error' : ''}>
              <Label for="email">E-Mail-Adresse*</Label>
              <Input type="text" value={this.state.email} name="email" id="email" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.email.message}</span>
            </div>
          </FormGroup>
        </Col>
      </Row>
      <h6>* Pflichtfelder - Diese Angaben benötigen wir, um Ihren Auftrag zu bearbeiten. Vielen Dank.</h6>
      </div>
    );
  }
}

export default UserAdress;


// WEBPACK FOOTER //
// ./src/components/FormGroups/UserAdress.js